<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{title}}
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" mat-dialog-close><mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon></button>
    </div>
</div>

<div mat-dialog-content class="nova__dialog__content">
    <mat-form-field data-qa-id="dateDialogDateInputField" style="width: 155px">
        <mat-label>{{dateTitle}}</mat-label>
        <input matInput [matDatepicker]="dateEdit" [placeholder]="dateTitle" [(ngModel)]="date">
        <mat-datepicker-toggle matSuffix [for]="dateEdit"></mat-datepicker-toggle>
        <mat-datepicker #dateEdit></mat-datepicker>
    </mat-form-field>
        
    <mat-dialog-actions class="nova__dialog__content__actions" align="end">
        <button mat-flat-button color="primary" data-qa-id="dateDialogSaveBtn" (click)="close(true)" [disabled]="!date">SAVE</button>
        <button mat-flat-button color="cancel" data-qa-id="dateDialogCancelBtn" (click)="close(false)">CANCEL</button>
    </mat-dialog-actions>
</div>
